import { Controller } from 'stimulus';
import { useHotkeys } from 'stimulus-use';

export default class extends Controller {
  static targets = ['button', 'panel'];

  connect() {
    this.index = 0;
    this.active = false;

    useHotkeys(this, {
      left: [this.onArrowKeyPress],
      right: [this.onArrowKeyPress],
    })
  }

  onBlur(ev) {
    this.active = false;
  }

  onFocus(ev) {
    this.active = true;
  }

  onSelect(ev) {
    const { target } = ev;
    const panelId = target.getAttribute('aria-controls');

    this.buttonTargets.forEach((button, index) => {
      if (button === target) {
        this.index = index;

        button.classList.add('font-bold');
        button.setAttribute('aria-selected', 'true');
        button.removeAttribute('tabindex');
      } else {
        button.classList.remove('font-bold');
        button.setAttribute('aria-selected', 'false');
        button.tabIndex = -1;
      }
    });

    this.panelTargets.forEach(panel => {
      if (panel.id == panelId) {
        panel.classList.remove('hidden');
      } else {
        panel.classList.add('hidden');
      }
    });
  }

  onArrowKeyPress(ev) {
    if (!this.active)
      return;

    switch(ev.key) {
      case 'ArrowLeft':
        if (this.index > 0) {
          this.buttonTargets[this.index - 1].focus();
          this.buttonTargets[this.index - 1].click();
        }

        break;
      case 'ArrowRight':
        if (this.index < this.buttonTargets.length - 1) {
          this.buttonTargets[this.index + 1].focus();
          this.buttonTargets[this.index + 1].click();
        }

        break;
    }
  }
}
